import { Dropdown } from "primereact/dropdown";
import { Constant } from "../../../../constants/constant";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { VariablesConstant } from "../../../../constants/variables";
import { ComStdService } from "../../../../services/common/ComStdService";
import { Dcs0201Service } from "../../../../services/dcs/Dcs0201Service";
import { toast } from "react-toastify";
import { useAppSelector } from "../../../../store/hook";

interface ConnectionProps {
  model?: any;
  dataCycle?: any;
  setDataCycle: (event: any) => void;
  handleChange?: (event: any) => void;
  handleChangeProtTp: (event: any) => void;
  handleChangeConnectTp: (event: any) => void;
  handleSelectSecModes?: (event: any) => void;
  handleSelectSecPolicies?: (event: any) => void;
  handleChangeDataMapping: (event: any) => void;
  onChangeHaveDataCycle?: (event: any) => void;
  onChangeHaveSecModes?: (event: any) => void;
  onChangeHaveSecPolicies?: (event: any) => void;
  haveDataCycle?: boolean;
  haveSecModes?: boolean;
  haveSecPolicies?: boolean;
}

export default function ConnectionInfo(props: ConnectionProps) {
  const { t, i18n } = useTranslation();

  const [connProtLst, setConnProtLst] = useState<any>();
  const [uaSecModesTcp, setUaSecModesTcp] = useState<any>();
  const [uaSecModesHttps, setUaSecModesHttps] = useState<any>();
  const [uaSecPolicies, setUaSecPolicies] = useState<any>();
  const [uaConnectTp, setUaConnectTp] = useState<any>();
  const [listDataMap, setListDataMap] = useState<any>();

  const lang = useAppSelector((state: any) => state.language.lang);
  const [filteredDataMap, setFilteredDataMap] = useState([]);

  // useEffect(() => {
  //   if(props.model.connProtTp){
  //     getDataMapByConnType(props.model.connProtTp.commCd)
  //   }
  // },[props.model])

  useEffect(() => {
    getConnProtTpLst();
    if (props.model.connProtTp) {
      getDataMapByConnType(props.model.connProtTp.commCd);
    }
    // if (props.data.isCreate) {
    //   setprops.model({
    //     ...props.model,
    //   });
    // } else {
    //   _getConnectionById(props.data);
    // }
  }, []);

  useEffect(() => {
    if (props.model.connProtTp && Object.keys(props.model.connProtTp).length > 0) {
      if (props.model.connProtTp.commCd === VariablesConstant.PROTOCOL_OPC_UA) {
        getUaConnectTpLst();
        getUaSecModesTcpLst();
        getUaSecModesHttpsLst();
        getUaSecPoliciesLst();
      }
    }
  }, [props.model.connProtTp]);

  const getConnProtTpLst = () => {
    let req = { upCommCd: Constant.CONNECTION_PROTOCOL_TYPE };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setConnProtLst(res.data.responseData);
      })
      .catch((err: any) => {});
  };

  const getUaConnectTpLst = () => {
    let req = { upCommCd: Constant.UA_CONNECT_TP };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setUaConnectTp(res.data.responseData);
      })
      .catch((err: any) => {});
  };

  const getUaSecModesTcpLst = () => {
    let req = { upCommCd: Constant.SECURITY_MODES_TCP };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setUaSecModesTcp(res.data.responseData);
      })
      .catch((err: any) => {});
  };

  const getUaSecModesHttpsLst = () => {
    let req = { upCommCd: Constant.SECURITY_MODES_HTTPS };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setUaSecModesHttps(res.data.responseData);
      })
      .catch((err: any) => {});
  };

  const getUaSecPoliciesLst = () => {
    let req = { upCommCd: Constant.SECURITY_POLICIES };
    ComStdService.getInstance()
      .getListTccoStd(req)
      .then((res: any) => {
        setUaSecPolicies(res.data.responseData);
      })
      .catch((err: any) => {});
  };

  const getDataMapByConnType = (connType: String) => {
    Dcs0201Service.getInstance()
      .getDataMapByConnType(connType)
      .then((res) => {
        if (res.data.status) {
          if (res.data.responseData && res.data.responseData.length > 0) {
            setListDataMap(res.data.responseData);
          } else {
            toast.warning("This connection protocol don't have data map");
          }
        }
      });
  };

  const search = (event: any) => {
    // Timeout to emulate a network connection
    setTimeout(() => {
      let _filteredDataMap;

      if (!event.query.trim().length) {
        _filteredDataMap = [...listDataMap];
      } else {
        _filteredDataMap = listDataMap.filter((item: any) => {
          return item.dataMapName.toLowerCase().startsWith(event.query.toLowerCase());
        });
      }

      setFilteredDataMap(_filteredDataMap);
    }, 250);
  };

  return (
    <>
      <div className="form-container">
        <div className="row align-items-center">
          <div className="col-lg-3 form-label-grid">
            <label htmlFor="validationInput" className="form-label">
              {t("dcs0101.form.label.connectionNm")}
              <strong className="strong-required"> *</strong>
            </label>
          </div>
          <div className="col-lg-9">
            <input value={props.model.connNm || ""} type="text" className="form-control" name="connNm" id="validationInput" onChange={props.handleChange} />
            <div className={`${props.model.connNm?.trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.connNm")}</div>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-3 form-label-grid">
            <label htmlFor="validationInput" className="form-label">
              {t("dcs0101.form.label.connectionProt")}
              <strong className="strong-required"> *</strong>
            </label>
          </div>
          <div className="col-lg-9">
            <Dropdown
              value={props.model.connProtTp}
              onChange={(e: any) => {
                props.handleChangeProtTp(e.value);
                getDataMapByConnType(e.value.commCd);
              }}
              options={connProtLst}
              optionLabel={Constant.SOUTH_KOREA === lang ? Constant.COMM_NM_KR : Constant.COMM_NM_EN}
              style={{ width: "100%" }}
            />
            <div className={`${props.model.connProtTp && Object.keys(props.model.connProtTp).length === 0 ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.connProtTp")}</div>
          </div>
        </div>

        {listDataMap && (
          <div className="row align-items-center">
            <div className="col-lg-3 form-label-grid">
              <label htmlFor="validationInput" className="form-label">
                {t("dcs0101.form.label.dataMap")}
                <strong className="strong-required"> *</strong>
              </label>
            </div>
            <div className="col-lg-9">
              <Dropdown
                style={{ width: "100%" }}
                value={props.model.sltDataMap}
                filter={true}
                onChange={(e) => props.handleChangeDataMapping(e.value)}
                options={listDataMap}
                optionLabel="dataMapName"
                className="w-full md:w-14rem"
              />
              <div className={`${props.model.sltDataMap && Object.keys(props.model.connProtTp).length === 0 ? "error-required" : "d-none"}`}>{t("dcs0201.message.required.field")}</div>
            </div>
          </div>
        )}

        <div className="row align-items-center">
          <div className="col-lg-3 form-label-grid">
            <label htmlFor="validationInput" className="form-label">
              {t("dcs0101.form.label.ip")}
              <strong className="strong-required"> *</strong>
            </label>
          </div>
          <div className="col-lg-9">
            <input value={props.model.ip || ""} type="text" className="form-control" name="ip" id="validationInput" onChange={props.handleChange} />
            <div className={`${props.model.ip?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.ip")}</div>
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-3 form-label-grid">
            <label htmlFor="validationInput" className="form-label">
              {t("dcs0101.table.header.port")}
              <strong className="strong-required"> *</strong>
            </label>
          </div>
          <div className="col-lg-9">
            <input value={props.model.port} type="number" className="form-control" name="port" id="validationInput" onChange={props.handleChange} />
            <div className={`${props.model.port?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.port")}</div>
          </div>
        </div>

        {props.model.connProtTp && props.model.connProtTp.commCd === VariablesConstant.PROTOCOL_MODBUS && (
          <>
            <div className="row align-items-center">
              <div className="col-lg-3 form-label-grid">
                <label className="form-label">
                  {t("dcs0101.form.label.slaveId")}
                  <strong className="strong-required"> *</strong>
                </label>
              </div>
              <div className="col-lg-9">
                <input value={props.model.slaveId} type="number" className="form-control" name="slaveId" id="validationInput" onChange={props.handleChange} />
                <div className={`${props.model.slaveId?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.slaveId")}</div>
              </div>
            </div>

            <div className="row align-items-center">
              <div className="col-lg-3 form-label-grid">
                <label className="form-label">
                  {t("dcs0101.form.label.offset")}
                  <strong className="strong-required"> *</strong>
                </label>
              </div>
              <div className="col-lg-9">
                <input value={props.model.dataOffset} type="number" className="form-control" name="dataOffset" id="validationInput" onChange={props.handleChange} />
                <div className={`${props.model.dataOffset?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.offset")}</div>
              </div>
            </div>

            <div className="row align-items-center">
              <div className="col-lg-3 form-label-grid">
                <label className="form-label">
                  {t("dcs0101.form.label.quantity")}
                  <strong className="strong-required"> *</strong>
                </label>
              </div>
              <div className="col-lg-9">
                <input value={props.model.quantity} type="number" className="form-control" name="quantity" id="validationInput" onChange={props.handleChange} />
                <div className={`${props.model.quantity?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.quantity")}</div>
              </div>
            </div>
          </>
        )}

        {props.model.connProtTp && props.model.connProtTp.commCd === VariablesConstant.PROTOCOL_MQTT && (
          <>
            <div className="row align-items-center">
              <div className="col-lg-3 form-label-grid">
                <label className="form-label">
                  {t("dcs0101.form.label.clientId")}
                  <strong className="strong-required"> *</strong>
                </label>
              </div>
              <div className="col-lg-9">
                <input value={props.model.clientId || ""} type="text" className="form-control" name="clientId" id="validationInput" onChange={props.handleChange} />
                <div className={`${props.model.clientId?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.clientId")}</div>
              </div>
            </div>

            <div className="row align-items-center">
              <div className="col-lg-3 form-label-grid">
                <label className="form-label">
                  {t("dcs0101.form.label.topic")}
                  <strong className="strong-required"> *</strong>
                </label>
              </div>
              <div className="col-lg-9">
                <input value={props.model.topic || ""} type="text" className="form-control" name="topic" id="validationInput" onChange={props.handleChange} />
                <div className={`${props.model.topic?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.topic")}</div>
              </div>
            </div>
          </>
        )}

        <div className="row align-items-center">
          <div className="col-lg-3 form-label-grid">
            <label htmlFor="validationInput" className="form-label">
              {t("dcs0101.form.label.username")}
            </label>
          </div>
          <div className="col-lg-9">
            <input value={props.model.username || ""} type="text" className="form-control" name="username" id="validationInput" onChange={props.handleChange} />
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-3 form-label-grid">
            <label htmlFor="validationInput" className="form-label">
              {t("dcs0101.form.label.pwd")}
            </label>
          </div>
          <div className="col-lg-9">
            <input value={props.model.pwd || ""} type="text" className="form-control" name="pwd" id="validationInput" onChange={props.handleChange} />
          </div>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-3 form-label-grid">
            <label className="form-label">
              {t("dcs0101.form.label.kafkaTopic")}
              <strong className="strong-required"> *</strong>
            </label>
          </div>
          <div className="col-lg-9">
            <input value={props.model.kafkaTopic || ""} type="text" className="form-control" name="kafkaTopic" id="validationInput" onChange={props.handleChange} />
            <div className={`${props.model.kafkaTopic?.toString().trim() === "" ? "error-required" : "d-none"}`}>{t("dcs0101.message.required.kafkaTopic")}</div>
          </div>
        </div>
        <div className="row align-items-center mb-3">
          <div className="col-lg-3 form-label-grid">
            <label htmlFor="validationInput" className="form-label">
              {t("dcs0101.form.label.dataCycle")}
            </label>
          </div>

          <div className="col-lg-9 d-flex">
            <div className="checkbox-radio">
              <input type="checkbox" id="md_checkbox_sp" checked={props.haveDataCycle} onChange={props.onChangeHaveDataCycle} />
              <label htmlFor="md_checkbox_sp">{t("dcs0101.form.label.dataCycle")}</label>
            </div>
            <br />
            {props.haveDataCycle && (
              <>
                {VariablesConstant.CRON_EXPRESSION?.map((ele: any, index: any) => (
                  <div key={index} className="checkbox-radio">
                    <input type="radio" name="data-cycle" checked={props.dataCycle === ele.value} id={`data-cycle-${index}`} value={ele.value} onChange={() => props.setDataCycle(ele.value)} />
                    <label htmlFor={`data-cycle-${index}`}>{Constant.SOUTH_KOREA === lang ? ele.labelKr : ele.label}</label>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
      {props.model.connProtTp && props.model.connProtTp.commCd === VariablesConstant.PROTOCOL_OPC_UA && (
        <div className="box-form mt-3">
          <div className="row mb-3">
            <div className="col-lg-2">
              <label htmlFor="validationInput" className="form-label">
                {t("dcs0101.form.label.connectionType")}
                <strong className="strong-required"> *</strong>
              </label>
            </div>
            <div className="col-lg-2">
              <Dropdown
                value={props.model.connectionType}
                onChange={(e) => props.handleChangeConnectTp(e.value)}
                options={uaConnectTp}
                optionLabel={Constant.SOUTH_KOREA === lang ? Constant.COMM_NM_KR : Constant.COMM_NM_EN}
                style={{ width: "100%" }}
                placeholder="-"
              />
              <div className={`${props.model.connectionType && Object.keys(props.model.connectionType).length === 0 ? "error-required" : "d-none"}`}>
                {t("dcs0101.message.required.connectionType")}
              </div>
            </div>
          </div>
          {props.model.connectionType && Object.keys(props.model.connectionType).length > 0 && (
            <>
              <div className="row">
                <div className="dcs-checkbox d-flex align-items-center mb-3">
                  <div className="checkbox-radio">
                    <input type="checkbox" id="md_checkbox_sm" checked={props.haveSecModes} onChange={props.onChangeHaveSecModes} />
                    <label htmlFor="md_checkbox_sm">{t("dcs0101.form.label.securityModes")}</label>
                  </div>
                  {props.haveSecModes && (
                    <div className="row mb-3 bg-white rounded-4 py-3" style={{ width: "100%" }}>
                      {props.model.connectionType.commCd === VariablesConstant.UA_CONNECT_TP_TCP && (
                        <div className="d-flex flex-wrap">
                          {uaSecModesTcp?.map((ele: any, index: any) => (
                            <div key={index} className="checkbox-radio">
                              <input
                                type="radio"
                                name="sec-modes"
                                checked={props.model.extraInfo.secModes === ele.commCd}
                                id={`sec-modes-${index}`}
                                value={ele.commCd}
                                onChange={props.handleSelectSecModes}
                              />
                              <label htmlFor={`sec-modes-${index}`}>{Constant.SOUTH_KOREA === lang ? ele.commNm : ele.commNmEn}</label>
                            </div>
                          ))}
                        </div>
                      )}
                      {props.model.connectionType.commCd === VariablesConstant.UA_CONNECT_TP_HTTPS && (
                        <div className="d-flex flex-wrap">
                          {uaSecModesHttps?.map((ele: any, index: any) => (
                            <div key={index} className="checkbox-radio">
                              <input
                                type="radio"
                                name="sec-modes"
                                checked={props.model.extraInfo.secModes === ele.commCd}
                                id={`sec-modes-${index}`}
                                value={ele.commCd}
                                onChange={props.handleSelectSecModes}
                              />
                              <label htmlFor={`sec-modes-${index}`}>{Constant.SOUTH_KOREA === lang ? ele.commNm : ele.commNmEn}</label>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="dcs-checkbox d-flex align-items-center">
                  <div className="checkbox-radio">
                    <input type="checkbox" id="md_checkbox_sp" checked={props.haveSecPolicies} onChange={props.onChangeHaveSecPolicies} />
                    <label htmlFor="md_checkbox_sp">{t("dcs0101.form.label.securityPolicies")}</label>
                  </div>
                  {props.haveSecPolicies && (
                    <div className="row bg-white rounded-4 py-3" style={{ width: "100%" }}>
                      <div className="d-flex flex-wrap row-gap-3">
                        {uaSecPolicies?.map((ele: any, index: any) => (
                          <div key={index} className="checkbox-radio">
                            <input
                              type="radio"
                              name="sec-policies"
                              checked={props.model.extraInfo.secPolicies === ele.commCd}
                              id={`sec-policies-${index}`}
                              value={ele.commCd}
                              onChange={props.handleSelectSecPolicies}
                            />
                            <label htmlFor={`sec-policies-${index}`}>{Constant.SOUTH_KOREA === lang ? ele.commNm : ele.commNmEn}</label>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
